import { CSV } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

const object = 'CSV'
const page = CSV

export const ImportCSV = Simple({
  id: '94a4f3a9-8c39-45e9-91b7-3a8766001a35',
  action: 'Import',
  object,
  page,
})

export const ExportCSV = Simple({
  id: '02bb6dd8-9bc1-4fef-bc27-bf2801953234',
  action: 'Export',
  object,
  page,
})

export type ImportExportCSVPermission = typeof ImportCSV | typeof ExportCSV
